import React from 'react'
import Modal from '../../elements/ModalBlue'
import Button from '../../elements/Button'

import { Wrapper, Title, Text, WrapperButton } from './styles'

import image from '../../../static/icon-veloe-background.svg'

class AddTagsModal extends React.Component {
  render() {
    const { handleClick } = this.props
    return (
      <Modal backgroundImage={image} position="right bottom">
        <Wrapper>
          <Title>Sua VeloeTag foi bloqueada</Title>
          <Text>
            Agora este veículo não vai mais ter acesso livre aos locais conveniados. Você receberá
            sua VeloeTag em até <b>10 dias úteis</b>, no endereço solicitado. Ela deverá ser
            recebida por uma pessoa maior de 18 anos com documento com foto em mãos. Fique
            tranquilo, a mensalidade será cobrada apenas após você receber e ativar a sua VeloeTag.
          </Text>
          <Text />

          <WrapperButton>
            <Button buttonType="darkBlue" text="Ok" onClick={() => handleClick()} />
          </WrapperButton>
        </Wrapper>
      </Modal>
    )
  }
}

export default AddTagsModal



// WEBPACK FOOTER //
// ./src/app/modules/ReceivedModal/index.js